import { Typography, useTheme } from "@mui/material";
import React from "react";

const PageTitle = ({ title }) => {
    const theme = useTheme();

    return (
        <Typography
            variant="h3"
            component="h1"
            sx={{
                fontSize: { xs: theme.typography.h5.fontSize, lg: theme.typography.h3.fontSize },
                overflowWrap: 'anywhere',
            }}
        >
            {title}
        </Typography>
    )
}


export default PageTitle;
